/**
 * @generated SignedSource<<9fb07b6be94a0c5b8aa11df5cfa94974>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BackfillClientContactsInput = {
  dryRun?: boolean | null;
  afterCompanyId?: number | null;
  limit?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type backfillClientContactsMutation$variables = {
  input: BackfillClientContactsInput;
};
export type backfillClientContactsMutation$data = {
  readonly backfillClientContacts: {
    readonly companiesProcessed: number | null;
    readonly companiesFailed: number | null;
    readonly contactsCreated: number | null;
    readonly dryRun: boolean | null;
    readonly lastCompanyId: number | null;
    readonly companiesRemaining: number | null;
  } | null;
};
export type backfillClientContactsMutation = {
  variables: backfillClientContactsMutation$variables;
  response: backfillClientContactsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BackfillClientContactsPayload",
    "kind": "LinkedField",
    "name": "backfillClientContacts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companiesProcessed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companiesFailed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contactsCreated",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dryRun",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastCompanyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companiesRemaining",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "backfillClientContactsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "backfillClientContactsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "abe9709f703e33008e42687ece63e566",
    "id": null,
    "metadata": {},
    "name": "backfillClientContactsMutation",
    "operationKind": "mutation",
    "text": "mutation backfillClientContactsMutation(\n  $input: BackfillClientContactsInput!\n) {\n  backfillClientContacts(input: $input) {\n    companiesProcessed\n    companiesFailed\n    contactsCreated\n    dryRun\n    lastCompanyId\n    companiesRemaining\n  }\n}\n"
  }
};
})();

(node as any).hash = "a89955ed9c420ab06a76e17c70fced36";

export default node;
